import moment from "moment";
import { DATE_FORMAT } from "./constants";

export function getMaxMinHours(max, min, isMinDateSelected) {
  let minTime = new Date();
  if (isMinDateSelected) {
    const offset = 60 - minTime.getMinutes();
    minTime = moment(minTime)
      .add(offset < 30 ? offset + 30 : offset, "minutes")
      .toDate();
  } else {
    minTime.setHours(parseInt(min, 10));
    minTime.setMinutes(0);
  }
  minTime.setSeconds(0);
  const maxTime = new Date();
  maxTime.setHours(parseInt(max, 10));
  maxTime.setMinutes(0);
  maxTime.setSeconds(0);

  return { minTime, maxTime };
}

export function formDateValue(time, date) {
  const t = moment(time);
  const d = moment(date);
  d.hours(t.hours());
  d.minutes(t.minutes());
  return d.format(DATE_FORMAT);
}
